import { render, staticRenderFns } from "./platticketpro-add-or-update.vue?vue&type=template&id=64209369&scoped=true&"
import script from "./platticketpro-add-or-update.vue?vue&type=script&lang=js&"
export * from "./platticketpro-add-or-update.vue?vue&type=script&lang=js&"
import style0 from "./platticketpro-add-or-update.vue?vue&type=style&index=0&id=64209369&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64209369",
  null
  
)

export default component.exports